import script from "./AddHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AddHome.vue?vue&type=script&setup=true&lang=js"

import "./AddHome.vue?vue&type=style&index=0&id=6b7f3f79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7f3f79"]])

export default __exports__